import { CLICK_TO_BUY } from '@johnlewispartnership/wtr-content-component-library/dist/component-library/constants/cmsResourceTypes';

import concatenatePromotionValues from 'redux/middleware/analytics/actions-to-track/utilities/concatenate-promotion-values';
import extractLineNumberFromSku from 'utils/extract-linenumber-from-sku';

import { getProductById } from 'redux/modules/entities/selectors/products';

// eslint-disable-next-line no-restricted-imports
import { getCurrentBreakpoint } from 'utils/mediaQueries';
import { productImpressions } from './product-impressions';

const getProp = (state = {}, propToResolve) => {
  let prop;

  switch (typeof propToResolve) {
    case 'function': {
      prop = propToResolve(state);
      break;
    }
    case 'string': {
      prop = propToResolve;
      break;
    }
    default:
      break;
  }

  return prop;
};

// TODO: Migrate all product to impression mapping to a shared selector utility
// REF: https://johnlewispartnership.atlassian.net/browse/SHOPEXP-90
export const createProductImpression = (
  state,
  {
    currentSaleUnitPrice: {
      price: { amount: price = '', currencyCode } = {},
      quantity: { uom = '' } = {},
    } = {},
    id: productId,
    lineNumber,
    name,
    promotions,
  } = {},
  list,
  index,
) => {
  return {
    currencyCode,
    id: lineNumber || extractLineNumberFromSku(productId),
    list: list ? list.toLowerCase() : list,
    name,
    offer: concatenatePromotionValues(state, promotions) || '',
    position: index + 1,
    price,
    product_sku: productId,
    uom,
  };
};

const getProductGridImpression = ({ index, listType: list, state, searchProduct }) => {
  const { id } = searchProduct;
  const product = getProductById(state, id || searchProduct);

  return createProductImpression(state, product, list, index);
};

const getClickToBuyImpressions = ({ aemComponent, index, listType: list, state }) => {
  const { resourceType, paragraphSystem } = aemComponent;
  if (resourceType !== CLICK_TO_BUY) return null;

  const { childComponents } = paragraphSystem;

  const [_tradingCell, { items }] = childComponents;

  return items
    .filter(({ searchProduct }) => searchProduct)
    .map(({ searchProduct }) => getProductById(state, searchProduct))
    .filter(product => product) // filter invalid elements
    .map(product => createProductImpression(state, product, list, index));
};

const filterItemsByCurrentBreakpoint = ({ items, listType }) => {
  const allowedTypes = ['Offer', 'mealdeal'];

  if (allowedTypes.includes(listType)) {
    return items;
  }
  const currentBreakpoint = getCurrentBreakpoint();

  const validBreakpoints = currentBreakpoint === 'xl' ? ['xl', 'default'] : [currentBreakpoint];

  return items?.filter(({ cqResponsive }) => {
    return cqResponsive?.deviceBreakpoints.some(
      ({ name, visible }) => validBreakpoints.includes(name) && visible,
    );
  });
};

const getImpressionsMap = (state = {}, fetch = () => [], list) => {
  const gridItems = fetch(state) || [];
  const listType = getProp(state, list);

  return filterItemsByCurrentBreakpoint({ items: gridItems, listType }).flatMap(
    ({ aemComponent, searchProduct }, index) => {
      if (aemComponent) {
        return getClickToBuyImpressions({ aemComponent, index, listType, state }) ?? [];
      }

      if (searchProduct) {
        return [getProductGridImpression({ index, listType, state, searchProduct })];
      }

      return null;
    },
  );
};

export default ({ fetch, list, taxonomy } = {}) =>
  state => {
    if (!fetch || typeof fetch !== 'function') return null;

    const impressions = getImpressionsMap(state, fetch, list);

    const taxonomyLevel = getProp(state, taxonomy);

    return productImpressions(impressions, taxonomyLevel);
  };
